import React from 'react';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.goToPrev = this.goToPrev.bind(this);
    this.goToNext = this.goToNext.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.prevPages = this.prevPages.bind(this);
    this.nextPages = this.nextPages.bind(this);
  }

  goToPrev() {
    const page = +this.props.match.params.page || 1;

    if (page > 1) {
      this.goToPage(page - 1);
    }
  }

  goToNext() {
    const page = +this.props.match.params.page || 1;

    if (page < this.props.pageCount) {
      this.goToPage(page + 1);
    }
  }

  goToPage(page) {
    this.props.onPageChanged(page);
  }

  prevPages() {
    const page = this.props.match.params.page || 1;

    if (page <= 6) {
      return [...Array(page - 1)].map((_, i) => (
        <button
          className="btn btn-default btn-sm"
          key={`prev${i + 1}`}
          onClick={() => this.goToPage(i + 1)}
        >
          {i + 1}
        </button>
      ));
    }

    return [
      <button
        className="btn btn-default btn-sm"
        key="prev1"
        onClick={() => this.goToPage(1)}
      >
                1
      </button>,
      <button
        className="btn btn-default btn-sm"
        key="prev2"
        onClick={() => this.goToPage(2)}
      >
                2
      </button>,
      <span key="3">
        {' '}
                ...
        {' '}
      </span>,
      <button
        className="btn btn-default btn-sm"
        key={`prev${page}` - 1}
        onClick={() => this.goToPage(page - 1)}
      >
        {page - 1}
      </button>,
    ];
  }

  nextPages() {
    const page = +this.props.match.params.page || 1;

    if (this.props.pageCount - page <= 4) {
      return [
        ...Array(
          this.props.pageCount > page ? this.props.pageCount - page : 0)].map(
        (_, i) => (
          <button
            className="btn btn-default btn-sm"
            key={`next${page + i + 1}`}
            onClick={() => this.goToPage(page + i + 1)}
          >
            {page + i + 1}
          </button>
        ));
    }

    return [
      <button
        className="btn btn-default btn-sm"
        key={`next${page + 1}`}
        onClick={() => this.goToPage(page + 1)}
      >
        {page + 1}
      </button>,
      <span key={this.props.pageCount + 1}>
        {' '}
                ...
        {' '}
      </span>,
      <button
        className="btn btn-default btn-sm"
        key={`next${this.props.pageCount - 1}`}
        onClick={() => this.goToPage(this.props.pageCount - 1)}
      >
        {this.props.pageCount - 1}
      </button>,
      <button
        className="btn btn-default btn-sm"
        key={`next${this.props.pageCount}`}
        onClick={() => this.goToPage(this.props.pageCount)}
      >
        {this.props.pageCount}
      </button>,
    ];
  }

  render() {
    const { t } = this.props
    return (
      <div className="card">
        <div className="content text-center">
          <button
            className="btn btn-default btn-sm pull-left"
            onClick={this.goToPrev}
          >
            <i className="fa fa-angle-left" />
            {' '}
                        {t("prevPage")}
          </button>

          {this.prevPages()}
          <button className="btn btn-default btn-sm active">
            {this.props.match.params.page || 1}
          </button>
          {this.nextPages()}

          <button
            className="btn btn-default btn-sm pull-right"
            onClick={this.goToNext}
          >
                        {t("nextPage")}
            <i className="fa fa-angle-right" />
          </button>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(withRouter(Pagination));



// WEBPACK FOOTER //
// ./src/components/common/pagination/index.js